import { createMuiTheme } from '@material-ui/core';

import shadows from './shadows';
import typography from './typography';
import palette from './palette';
import overrides from './overrides';

const theme = createMuiTheme(
  {
    palette,
    shadows,
    typography,
    overrides: overrides,
    zIndex: {
      appBar: 2200,
      drawer: 2100
    }
  }
);

export default theme;
